import { defaultTo } from 'ramda';
import { EPackageServiceType } from '../../../../../../PayPackageMicrofrontend/types/serviceType';

const SERVICE_ICONS = {
  [EPackageServiceType.Top]: 'top3',
  [EPackageServiceType.Premium]: 'premium',
  [EPackageServiceType.Paid]: 'publication',
  [EPackageServiceType.Standard]: 'standard',
  [EPackageServiceType.Auction]: 'auction',
};

export const getServiceIcon = (serviceType: EPackageServiceType): string => {
  return defaultTo('', SERVICE_ICONS[serviceType]);
};
